import { useEffect, useState } from "react";
import { Toolbar, AppBar, Box, Typography, Button, Tooltip } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as Logo } from "./../../../logo.svg";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { daysLeftSelector } from "../../../store/proposalSlice";
import CommitteesSelector from "./CommitteesSelector";
import { contactSelector } from "../../../store/userSlice";
import { Instructions, Print } from "./Icon";
import InstructionsModal from "./InstructionsModal";
import ProfileMenu from "../../../Controllers/UserMenu";

export const toolbarHeight = 80;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
    "& > *": {
      marginLeft: theme.spacing(6),
    },
    marginRight: theme.spacing(2),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    paddingRight: theme.spacing(1),
    minHeight: toolbarHeight,
    backgroundColor: process.env.REACT_APP_TOOLBAR_COLOR || "#FFF",
    color: "black",
  },
  title: {
    position: "absolute",
    left: 0,
    marginLeft: "18%",
  },
  tabs: {
    marginTop: 25,
    marginRight: 100,
  },
  pairsValue: {
    fontWeight: 600,
    marginLeft: 7,
  },
  buttonsWrapper: {
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  addApplicantButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover,
    },
    color: theme.palette.gif.green.color,
    backgroundColor: theme.palette.gif.green.background,
  },
  pdfButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  deleteButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
  },
  logo: {
    position: "absolute",
    left: 85,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
}));

export default function ApplicationBar(props) {
  const classes = useStyles();
  const { handlePrint } = props;
  const history = useHistory();
  const contact = useSelector(contactSelector);
  const daysLeft = useSelector(daysLeftSelector);
  const [instructionsOpen, setInstructionsOpen] = useState(false);
  const [infos, setInfos] = useState([]);

  useEffect(() => {
    const infos = [
      { key: "User: ", value: contact?.displayname },
    ];
    setInfos(infos);
  }, [contact, daysLeft]);

  return (
    <>
      <AppBar position="absolute" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Logo className={classes.logo} onClick={() => history.push("/")} />
          <Box className={classes.root}>
            <CommitteesSelector className={classes.title} />
            {infos.map((info) => (
              <Tooltip
                title={info.tooltip || ""}
                placement="bottom"
                key={info.key}
              >
                <Box>
                  <Typography
                    className={classes.pairsKey}
                    component="span"
                    variant="subtitle2"
                    color="inherit"
                    noWrap
                  >
                    {info.key}
                  </Typography>
                  <Typography
                    className={classes.pairsValue}
                    component="span"
                    color="inherit"
                    noWrap
                  >
                    {info.value}
                  </Typography>
                </Box>
              </Tooltip>
            ))}
            <Box className={classes.buttonsWrapper}>
              <Button
                size="small"
                disableElevation
                variant="contained"
                className={classes.button}
                startIcon={<Print />}
                onClick={handlePrint}
              >
                Print
              </Button>
              <Button
                size="small"
                disableElevation
                variant="contained"
                className={classes.button}
                startIcon={<Instructions />}
                onClick={() => setInstructionsOpen(true)}
              >
                Instructions
              </Button>
            </Box>
            <ProfileMenu open={true} />
          </Box>
        </Toolbar>
      </AppBar>
      <InstructionsModal
        open={instructionsOpen}
        onClose={() => setInstructionsOpen(false)}
      />
    </>
  );
}
